export const supplier = () => ({
    maxWidth: '735px',
});
